import { SegmentService } from './SegmentService';

export { SegmentService }